/**
 * isObject
 * @param object
 * @returns {boolean}
 */
export const isObject = (object) => {
  return object !== null && typeof object === 'object';
};

/**
 * isDomNodeType
 * @param node
 * @param nodeType
 * @returns {boolean}
 */
export const isDomNodeType = (node, nodeType = 1) => {
  return (
    node !== null && typeof node === 'object' && node.nodeType === nodeType
  );
};

/**
 * isDefined
 * @param val
 * @returns {boolean}
 */
export const isDefined = (val) => {
  return typeof val !== 'undefined';
};

/**
 * isBoolean
 * @param bool
 * @returns {boolean}
 */
export const isBoolean = (bool) => {
  return typeof bool === 'boolean';
};

/**
 * isFunction
 * @param fn
 * @returns {boolean}
 */
export const isFunction = (fn) => {
  return typeof fn === 'function';
};
